import moment from "moment";

export const LAST_THERAPY_DATE_REQUIRED_MESSAGE =
  "Poslednji mesec dospeća je obavezan kada je izabran datum dospeća.";

export const LAST_THERAPY_DATE_BEFORE_WILL_BE_READY_MESSAGE =
  "Poslednji mesec dospeća ne može biti pre meseca dospeća terapije.";

/**
 * Validate the reminder schedule a pharmacist attaches to an RFZO therapy.
 *
 * The backend generates one reminder per month from willBeReady's month up to
 * lastTherapyDate's month (inclusive) and does not validate the pair itself:
 * a missing lastTherapyDate or an earlier month silently yields ZERO reminders
 * while the request is still marked as processed.
 *
 * An empty willBeReady is a legitimate "this was the last therapy" answer, so
 * nothing is required in that case.
 *
 * Returns the error message for the lastTherapyDate field, or null when the
 * pair is valid.
 */
export const validateTherapySchedule = (
  willBeReady: Date | null | undefined,
  lastTherapyDate: Date | null | undefined,
): string | null => {
  if (!willBeReady) {
    return null;
  }
  if (!lastTherapyDate) {
    return LAST_THERAPY_DATE_REQUIRED_MESSAGE;
  }
  if (!moment(lastTherapyDate).isSameOrAfter(moment(willBeReady), "month")) {
    return LAST_THERAPY_DATE_BEFORE_WILL_BE_READY_MESSAGE;
  }
  return null;
};
